function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import MediaBase from "./MediaBase";
import MediaButtonbar from "./MediaButtonbar";
import ImageAnnotations from "./ImageAnnotationsBase";

const NavSettings = () => React.createElement("div", null);

class LayoutAnnotateImage extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onAnnotationsChange", array => {
      if (this.props.onChange) {
        this.props.onChange(_extends({}, this.props.formData, {
          imageAnnotations: array
        }));
      }
    });
  }

  render() {
    const _this$props = this.props,
          media = _this$props.media,
          mediaId = _this$props.mediaId,
          formData = _this$props.formData,
          editable = _this$props.editable,
          editing = _this$props.editing,
          settings = _this$props.settings,
          menu = _this$props.menu,
          onSave = _this$props.onSave;
    const imageUrl = formData.imageUrl,
          imageAnnotations = formData.imageAnnotations;

    if (!imageUrl) {
      return React.createElement(MediaBase, this.props, React.createElement(MediaButtonbar, this.props));
    }

    return React.createElement(React.Fragment, null, React.createElement(MediaBase, _extends({}, this.props, {
      expanded: true
    }), React.createElement(ImageAnnotations, {
      imageUrl: imageUrl,
      imageAnnotations: imageAnnotations,
      onChange: this.onAnnotationsChange
    }), React.createElement(NavSettings, _extends({}, this.props, {
      settings: settings
    }))), this.props.children);
  }

}

_defineProperty(LayoutAnnotateImage, "defaultProps", {
  editable: false,
  editing: false,
  mediaId: undefined,
  media: {
    mediaType: undefined
  },
  imageAnnotations: [],
  buttons: []
});

export default LayoutAnnotateImage;